<template>
  <b-form-group
    label="Kasa"
    label-for="title"
  >
    <v-select
      v-model="dataItem.id_safes"
      :options="safes"
      label="title"
      :reduce="item => item.id"
      placeholder="Seçiniz"
    >
      <template v-slot:option="option">
        <div class="font-weight-bold">
          {{ option.title }}
        </div>
      </template>
    </v-select>
  </b-form-group>
</template>

<script>
import {
  BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'BankAccounts',
  components: {
    BFormGroup,
    vSelect,
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
    safes() {
      return this.$store.getters['safes/dataList']
    },
  },
  created() {
    this.getSafes()
  },
  methods: {
    getSafes() {
      this.$store.dispatch('safes/getDataList', {
        select: [
          'safes.id AS id',
          'safes.title AS title',
        ],
      })
    },
  },
}
</script>
